/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UploadTaskOverview } from "./UploadTaskOverview";
import {
  UploadTaskOverviewFromJSON,
  UploadTaskOverviewFromJSONTyped,
  UploadTaskOverviewToJSON,
  UploadTaskOverviewToJSONTyped,
} from "./UploadTaskOverview";

/**
 *
 * @export
 * @interface ApiUploadtasksOverviewList200Response
 */
export interface ApiUploadtasksOverviewList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiUploadtasksOverviewList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiUploadtasksOverviewList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiUploadtasksOverviewList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<UploadTaskOverview>}
   * @memberof ApiUploadtasksOverviewList200Response
   */
  results: Array<UploadTaskOverview>;
}

/**
 * Check if a given object implements the ApiUploadtasksOverviewList200Response interface.
 */
export function instanceOfApiUploadtasksOverviewList200Response(
  value: object
): value is ApiUploadtasksOverviewList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiUploadtasksOverviewList200ResponseFromJSON(
  json: any
): ApiUploadtasksOverviewList200Response {
  return ApiUploadtasksOverviewList200ResponseFromJSONTyped(json, false);
}

export function ApiUploadtasksOverviewList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiUploadtasksOverviewList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(UploadTaskOverviewFromJSON),
  };
}

export function ApiUploadtasksOverviewList200ResponseToJSON(
  json: any
): ApiUploadtasksOverviewList200Response {
  return ApiUploadtasksOverviewList200ResponseToJSONTyped(json, false);
}

export function ApiUploadtasksOverviewList200ResponseToJSONTyped(
  value?: ApiUploadtasksOverviewList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(UploadTaskOverviewToJSON),
  };
}
